import React, { useState } from 'react';

const HeroDirectorHero = () => {
  return (
    <section className="relative min-h-screen w-full bg-white pt-20">
      {/* Hero Image */}
      <div className="relative w-full h-[60vh]">
        <img
          src="https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/m1x8sevv_IMG_1731_2.jpg"
          alt="Rrammy - Film Director"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white/50"></div>
      </div>

      {/* Hero Content */}
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
        <h1 className="text-4xl md:text-5xl font-light text-gray-800 mb-4">
          Director & Writer
        </h1>
        <p className="text-lg text-gray-600 font-light mb-6">
          Mumbai, India • Available Worldwide
        </p>
        <p className="text-xl text-gray-700 font-light max-w-3xl leading-relaxed">
          Creating compelling brand stories and cinematic narratives that resonate. 
          From award-winning short films to high-impact commercials for India's leading brands.
        </p>
      </div>
    </section>
  );
};

export default HeroDirectorHero;